import React, { useState } from 'react'
import { actorLabel, decisionKindLabel } from '@/utils/pixel-warmup-panel'

interface Decision {
    id: string
    kind: string
    actor: string
    status: string
    mode: string | null
    error: string | null
    decided_at: string | null
}

interface WarmupHistoryProps {
    decisions: Decision[] | null
    loading: boolean
    onOpen: () => void
}

const formatWhen = (value: string | null) => (value ? new Date(value).toLocaleString() : '')

/** What Turba and the owner decided for this campaign, newest first. Read when the owner opens it. */
const WarmupHistory: React.FC<WarmupHistoryProps> = ({ decisions, loading, onOpen }) => {
    const [open, setOpen] = useState(false)

    return (
        <div data-testid="warmup-history">
            <button
                type="button"
                aria-expanded={open}
                className="tw:text-xs tw:text-blue-400 tw:hover:underline"
                onClick={() => {
                    if (!open) onOpen()
                    setOpen(!open)
                }}
            >
                {open ? 'Hide history' : 'Show history'}
            </button>
            {open && (
                <ul className="tw:!m-0 tw:!mt-2 tw:!p-0 tw:list-none tw:text-xs">
                    {loading && <li>Loading</li>}
                    {!loading && decisions && decisions.length === 0 && <li>Nothing has been decided yet.</li>}
                    {(decisions || []).map((decision) => (
                        <li
                            key={decision.id}
                            className="tw:flex tw:flex-wrap tw:gap-2 tw:py-0.5"
                            data-testid="decision"
                        >
                            <span className="tw:text-gray-200">{formatWhen(decision.decided_at)}</span>
                            <span className="tw:font-medium">{decisionKindLabel(decision.kind)}</span>
                            <span>{actorLabel(decision.actor)}</span>
                            <span className="tw:text-gray-200">{decision.status}</span>
                            {decision.error && <span className="tw:text-yellow-300">{decision.error}</span>}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    )
}

export default WarmupHistory
